import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/components/ui/avatar"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
  DropdownMenuSeparator
} from "@/components/ui/dropdown-menu"
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import { Link } from "react-router-dom";
import { ChevronsUpDownIcon, LogOutIcon, CircleUserRound } from "lucide-react"
import { useSession } from "@/providers/SessionProvider";
import { MOD_USER_PROFILE } from '@/configs/ModulesConfig';
import { UserTypes } from '@/configs/AppConfig';


export function NavUser() {
  const { logout, user, userType } = useSession();
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="bg-transparent hover:bg-transparent text-white hover:text-white"
            >
              <div className="w-0 mr-2 h-full border-r border-secondary" />
              <div className="grid flex-1 mr-2 text-left text-sm leading-tight">
                <span className="truncate font-medium text-right">{user?.name}</span>
                <span className="truncate text-xs text-right">{user?.email}</span>
              </div>
              <Avatar className="h-8 w-8 rounded-full">
                <AvatarImage src={user?.avatar} alt={user?.name} />
                <AvatarFallback className="rounded-lg">{user?.name?.charAt(0)?.toUpperCase()}</AvatarFallback>
              </Avatar>
              {/* <ChevronsUpDownIcon className="ml-auto size-4" /> */}
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg z-9999999"
            side={"bottom"}
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                {/* <Avatar className="h-8 w-8 rounded-lg">
                  <AvatarImage src={user?.avatar} alt={user?.name} />
                  <AvatarFallback className="rounded-lg">{user?.name?.charAt(0)?.toUpperCase()}</AvatarFallback>
                </Avatar> */}
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-medium">{user?.name}</span>
                  <span className="truncate text-xs">{user?.email}</span>
                </div>
              </div>
            </DropdownMenuLabel>
            {userType === UserTypes.SYSTEM_USER && <>
              <DropdownMenuItem asChild>
                <Link to={MOD_USER_PROFILE.base_path} className="cursor-pointer">
                  <CircleUserRound
                  />
                  Profile
                </Link>
              </DropdownMenuItem>
              <DropdownMenuSeparator />
            </>}
            <DropdownMenuItem onClick={logout}>
              <LogOutIcon
              />
              Log out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu >
  )
}
